<p-autoComplete #autoComplete
                [ngClass]="{ 'ng-invalid': isInvalid }"
                appendTo="body"
                [disabled]="disabled"
                [inputId]="$any(inputId)"
                [placeholder]="placeholder"
                [(ngModel)]="value"
                [suggestions]="filteredSuggestions"
                [field]="displayField"
                [dataKey]="idField"
                [dropdown]="true"
                [multiple]="true"
                [readonly]="isDisabled"
                [virtualScroll]="false"
                (onShow)="showingSuggestions()"
                (onHide)="hidingSuggestions()"
                [unique]="true"
                [emptyMessage]="emptyListMessage"
                [showEmptyMessage]="!!emptyListMessage"
                (completeMethod)="onComplete($event)">
</p-autoComplete>